export const updates = [
  { id: 1, time: '刚刚', tag: '突发', content: '某知名导演被拍到与神秘女子同回住所，工作室暂未回应' },
  { id: 2, time: '12分钟前', tag: '更新', content: '《你好星期六》下期预告：某影帝首次参加综艺，表现引期待' },
  { id: 3, time: '28分钟前', tag: '确认', content: '某歌手经纪公司确认：新专辑将于下月15日正式发布' },
  { id: 4, time: '45分钟前', tag: '爆料', content: '知情人透露某当红小生正在接触好莱坞项目，细节尚在保密阶段' },
  { id: 5, time: '1小时前', tag: '快讯', content: '某视频平台宣布获得多部热门剧集独家版权，会员权益全面升级' },
  { id: 6, time: '1.5小时前', tag: '热闻', content: '某综艺节目录制现场发生意外，一名工作人员受轻伤已送医' },
  { id: 7, time: '2小时前', tag: '首发', content: '某品牌官宣全新代言人，广告大片拍摄花絮同步曝光' },
  { id: 8, time: '3小时前', tag: '快讯', content: '某电影节公布评审团名单，两位华人导演入选主竞赛单元评审' },
  { id: 9, time: '4小时前', tag: '更新', content: '某剧组路透引发热议，网友对服化道造型评价两极分化' },
];